import React from 'react';
import rulePopout from 'components/triggers/RulePopout';
import CallConversationSelection from './CallConversationSelection';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import FlatButton from 'components/pure/utils/FlatButton';
import {CallConditionType} from 'records/CallTrigger';

class CallConversationSelectionContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedContextType: null,
      selectedValue: null,
    };

    this.selectedValueChanged = this.selectedValueChanged.bind(this);
    this.selectedContextTypeChanged = this.selectedContextTypeChanged.bind(this);
    this.saveSelection = this.saveSelection.bind(this);
  }

  selectedValueChanged(value) {
    // prevent dragging sliders from causing a clickout of the popout
    this.props.blockClickOutTimeout();
    this.setState({
      selectedValue: value,
    });
    const context = CallConditionType.getCallCondition({
      type: this.state.selectedContextType,
      value,
    });
    this.props.updateSelection && this.props.updateSelection(context);
  }

  /**
   * Indicate to this component that the context type has changed
   * @param contextType the type of the context that has been changed to
   * @param value the value of the context that has been changed to, default to null.
   * If the context does not use a value, then pass in something truthy to reflect that (say "dummy")
   * and as such the context is "ready" (for the UI to enable the save button)
   */
  selectedContextTypeChanged(contextType, value = null) {
    if (value != null) {
      this.setState({
        selectedContextType: contextType,
        selectedValue: value,
      });
    } else {
      // if value is null, we just don't set it, so any existing value stays
      this.setState({
        selectedContextType: contextType,
      });
    }
    const detailValue = value != null ? value : this.state.selectedValue;
    const context = CallConditionType.getCallCondition({
      type: contextType,
      value: detailValue,
    });

    context.ready() && this.props.updateSelection && this.props.updateSelection(context);
  }

  saveSelection() {
    const newContext = CallConditionType.getCallCondition({
      type: this.state.selectedContextType,
      value: this.state.selectedValue,
    });
    return this.props.saveSelection(newContext);
  }

  componentDidMount() {
    this.setState({
      selectedContextType: this.props.selectedContextType,
      selectedValue: this.props.selectedValue,
    });
  }

  render() {
    const canSave =
      this.state.selectedContextType === CallConditionType.CALL_SCHEDULED ||
      (!!this.state.selectedContextType && !!this.state.selectedValue);
    return (
      <div className="rule-select-popup">
        <CallConversationSelection
          {...this.props}
          {...this.state}
          selectedContextTypeChanged={this.selectedContextTypeChanged}
          selectedValueChanged={this.selectedValueChanged}
        />
        <div className="selection-buttons">
          <button
            className={canSave ? 'save' : 'save disabled'}
            disabled={!canSave}
            onClick={() => this.saveSelection()}>
            <CheckIcon color={canSave ? 'white' : 'gray'} />
          </button>
          <FlatButton onClick={() => this.props.closeRequest('cancel')}>Cancel</FlatButton>
        </div>
      </div>
    );
  }
}

export default rulePopout(CallConversationSelectionContainer);
